import Vue from 'vue'

export const validationMessages: Record<string, string> = {
  required: 'Dit veld is verplicht.',
  email: 'Voer een geldig e-mailadres in.',
  maxValue100: 'Waarde moet kleiner zijn dan 100.',
  sameAsPassword: 'Nieuw wachtwoord en herhaling wachtwoord komen niet overeen.',
  checkboxRequired: 'Dit veld is verplicht.'
}

// A single resolved validation error.
interface SingleError {
  type: string
  message: string
}

// A Vuelidate-like validation state: `$error`/`$invalid` flags plus one boolean per rule.
type ValidationState = Record<string, unknown>

// The injected members are provided by an ancestor form component; declare them on
// `this` so the computed bodies are typed without changing the runtime options.
type ErrorExtractorThis = Vue & {
  formValidation: Record<string, ValidationState> | false
  formServerErrors: () => Record<string, string[]>
  name: string
  validation: ValidationState
  serverErrors: string[]
  preferredValidation: ValidationState | undefined
  preferredServerErrors: string[] | undefined
  error: SingleError | undefined
}

export default Vue.extend({
  inject: {
    formValidation: { default: false },
    formServerErrors: { default: () => ({}) }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    validation: {
      type: Object,
      default: () => { }
    },
    serverErrors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    preferredValidation (this: ErrorExtractorThis): ValidationState | undefined {
      if (Object.prototype.hasOwnProperty.call(this.$options.propsData, 'validation')) return this.validation
      return this.name ? (this.formValidation as Record<string, ValidationState>)[this.name] : this.validation
    },
    preferredServerErrors (this: ErrorExtractorThis): string[] | undefined {
      return this.name ? this.formServerErrors()[this.name] : this.serverErrors
    },
    error (this: ErrorExtractorThis): SingleError | undefined {
      if (!(this.preferredValidation && this.preferredValidation.$error)) {
        return
      }
      let singleError: SingleError | undefined
      const validation = this.preferredValidation
      Object.keys(validation).forEach((key) => {
        if (!key.startsWith('$') && typeof validation[key] === 'boolean' && !validation[key]) {
          singleError = {
            type: key,
            message: validationMessages[key]
          }
        }
      })
      return singleError
    },
    hasError (this: ErrorExtractorThis): boolean {
      return ((this.error && (this.error as unknown as { length?: number }).length !== 0) || (this.preferredServerErrors && this.preferredServerErrors.length > 0)) as boolean
    },
    errorLabel (this: ErrorExtractorThis): string {
      return (this.preferredServerErrors && this.preferredServerErrors.length > 0)
        ? this.preferredServerErrors[0]
        : (this.error ? this.error.message : '')
    }
  }
})
